export default class CommandsController {
  #requestService;
  #paths;

  constructor(requestService, paths) {
    this.#requestService = requestService;
    this.#paths = paths;
  }

  async updateTaskAsComplete(taskId) {
    const path = this.#paths.completeTask(taskId);
    const { data } = this.#requestService.Post(path, { value: true });
    return data;
  }
}

